import { ArrowRight } from "@untitledui/icons";
import { Link } from "react-router";
import { type AppResponse, type Program } from "../state/api.types";
import { compactFormatter } from "../utilities/analyticsHelpers";
import { programDetailsLink } from "../utilities/links";
import { ProgramTypeIcon } from "./ProgramTypeIcon";
import { HoverCard } from "./shared/HoverCard";

type ProgramCardProps = {
  app: AppResponse;
  program: Program;
  activeAccounts?: number;
};

export const ProgramCard = ({
  app,
  program,
  activeAccounts,
}: ProgramCardProps) => {
  return (
    <Link to={programDetailsLink(app.slug, program.uuid)}>
      <HoverCard className="h-[162px] w-[300px]">
        <div className="flex w-full flex-col justify-between">
          <div
            className="text-primary-900 truncate text-xl font-semibold"
            title={program.name}
          >
            {program.name}
          </div>
          <div className="flex flex-row items-center justify-between">
            <div className="flex items-center gap-1 text-secondary">
              <ProgramTypeIcon programType={program.program_type} />
              <span className="font-mono text-xl">
                {compactFormatter.format(activeAccounts ?? 0)}
              </span>
            </div>
            <ArrowRight className="size-5 text-secondary" />
          </div>
        </div>
      </HoverCard>
    </Link>
  );
};
